import React from "react";
import { Link } from "gatsby";

import * as classes from "./Card.module.css";
import BackgroundImage from "gatsby-background-image";

export const CardContainer = ({ children }) => {
  return <div className={classes.container}>{children}</div>;
};

export const LargeCard = ({ children }) => {
  return <div className={classes.largeCard}>{children}</div>;
};

const Card = ({
  title,
  subtitle,
  text,
  image,
  link,
  white,
  linkText,
  smallImage,
}) => {
  return (
    <BackgroundImage
      className={white ? `${classes.card} ${classes.white}` : classes.card}
      style={{
        backgroundSize: smallImage && "200px auto",
      }}
      fluid={image}
    >
      <div className={classes.spacer} />
      <div className={classes.text}>
        <p className={classes.title}>{title}</p>
        {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
        <p className={classes.content}>{text}</p>
        <div className={classes.grower} />
        {link && <Link to={link}>{linkText || "Read More"}</Link>}
      </div>
    </BackgroundImage>
  );
};

export default Card;
